import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';
import {UploadPref, CHUNK_SIZE_DEFAULT} from '../constants';

/**
 * Get chunk size for uploads
 * @returns chunk size for uploads
 */
export const getUploadChunkSize = () => {
	const prop = getPublicProperty(UploadPref.CHUNK_SIZE);
	const chunkSize = prop ? parseInt(prop) * 1000 * 1000 : CHUNK_SIZE_DEFAULT;
	return chunkSize || CHUNK_SIZE_DEFAULT;
};
